import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';


import { YoutubeModalComponent }  from '../youtube-modal/youtube-modal.component';


/**
 * Summary
 *    Simple component providing a button to open a YoutubeModalComponent with
 *    a specified video.
 *
 * @copyright 2017 ReallyB2B Limited
 */
@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnInit {

  // URL of the video
  @Input() videoUrl: string;

  // Button label
  @Input() buttonText: string;

  // Additional CSS classes to add to button
  @Input() buttonClass: string;


  constructor(
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
  }


  /**
   * Opens the YoutubeModalComponent dialog and passes the sanitized videoUrl
   */
  openVideoPlayer() {
    const dialogRef = this.dialog.open(YoutubeModalComponent, {
      data: {
        videoUrl: this.videoUrl,
      },
      panelClass: 'feature-modal-dialog',
    });
  }
}
